import React from 'react';
import AgencyDetailsCard from 'components/Common/AgencyDetailsCard';
import Table from 'components/Table';
import Button from 'components/Common/Button';
import DataVisualized from 'components/Common/DataVisualized';
import History from 'components/Common/History';

const InformationsDetails = ({ activation, loading }) => {
  const columns = [
    {
      Header: 'Gratuité',
      accessor: 'Gratuité',
      Cell: ({ row }) => (
        <div className="text-brand-lightBlue">{row.original.name}</div>
      ),
    },
    {
      Header: 'Stock initial',
      accessor: 'Stock_initial',
      Cell: ({ row }) => (
        <div className="text-brand-lightBlue">{row.original.quantity}</div>
      ),
    },
    {
      Header: 'Stock restants',
      accessor: 'Stock_restants',
      Cell: ({ row }) => (
        <div className="text-brand-lightBlue">
          {row.original.quantity - (row.original.quantityOut || 0)}
        </div>
      ),
    },
    {
      Header: 'Action',
      accessor: '',
      Cell: ({ row }) => (
        <Button
          isIconOnly
          className="mx-auto"
          text="Consulter"
          icon="mdi-chevron-right"
          color="blue"
          size="small"
        />
      ),
    },
  ];
  return (
    <div className="p-4 border">
      <div className="pb-6">
        <AgencyDetailsCard loading={loading} activation={activation} />
      </div>
      {/* table  */}
      <div className="pb-6">
        {/* title */}
        <h1 className="text-2xl text-brand-darkBlue font-semibold pb-2">
          Etat du stock global
        </h1>
        <div className="">
          <Table
            loading={loading}
            data={(activation.agencyStock || {}).products || []}
            columns={columns}
          />
        </div>
      </div>
    </div>
  );
};

export default InformationsDetails;
